import { render, staticRenderFns } from "./looks.vue?vue&type=template&id=c55fc296&scoped=true"
import script from "./looks.vue?vue&type=script&lang=js"
export * from "./looks.vue?vue&type=script&lang=js"
import style0 from "./looks.vue?vue&type=style&index=0&id=c55fc296&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55fc296",
  null
  
)

export default component.exports